var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NavHeader'),_c('NavHeaderMobile'),_c('Banner'),_c('div',{staticClass:"g-container wrapper"},[_c('Deploy'),_c('Customize')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }